import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import { useKeycloak } from '@react-keycloak/web';

import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { loadPeriodos } from '../../store/actions/Periodos';

import Grid from '@material-ui/core/Grid';
import Alert from '@material-ui/lab/Alert'
import Typography from '@material-ui/core/Typography';
import Container from '@material-ui/core/Container';
import Box from '@material-ui/core/Box';
import { Paper } from '@material-ui/core';

import CandidatoService from '../../services/Candidato';

import Title from '../../components/Title/Title';
import Toast from '../../components/Toast/Toast';
import PopUpLegenda from '../../components/Legenda/PopUpLegenda';

import DadosGerais from '../../forms/DadosGerais/DadosGerais';
import Endereco from '../../forms/Endereco/Endereco';
import Email from '../../forms/Email/Email';
import { TelefoneUnitario as TelefonePrincipal, TelefoneUnitario as TelefoneSecundario } from '../../forms/Telefone/TelefoneUnitario';
import NecessidadeEspecial from '../../forms/NecessidadeEspecial/NecessidadeEspecial';
import Sabatista from '../../forms/Sabatista/Sabatista';
import Password from '../../forms/Password/Password';
import ButtonsForm from '../../forms/Buttons/ButtonsForm';

import { getEdicaoCompleta, isInscricoesAbertas } from '../../helper/ContextHelper';
import { isCPFInvalid } from '../../helper/ValidationHelper';
import { filterPersistence } from '../../helper/ParseStateHelper';
import { cpfMask, removeCpfMask } from '../../helper/MaskHelper';
import { parseDate, toDate } from '../../helper/DateHelper';

import keycloak, { handleAutoLogin } from '../../security/keycloak';

import { MenuContext } from '../../context/MenuContext';

import logo from '../../assets/img/logo.png';

import Private from '../../layouts/private/Private';
import Public from '../../layouts/public/Public';

export const InscricaoForm = props => {
    const [ keycloak, ] = useKeycloak();

    return (
        <>
            {keycloak.authenticated ?
                <Private>
                    <Form {...props} />
                </Private>
            :
                <Public>
                    <Container component="main" maxWidth="xl" style={{ marginTop: '24px' }}>
                        <Form {...props} />
                    </Container>
                </Public>
            }
        </>
    )
}

export class Form extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: false,
      loadingButtonFind: false,
      loadingButtonSave: false,
      id: '',
      cpf: '',
      isInscrito: false,
      history: {
        path: null,
        state: null,
      },
      naoPodeFazerAlteracao: false,
    }
  }

  // CONTEXTO DE MENU
  static contextType = MenuContext;

  // FECHANDO MENU
  closeMenu = async () => {
    const { open, setOpen } = this.context;
    if (open) await setOpen(!open);
  }

  setToast = t => this.Toast = t;  
  setDadosGerais = d => this.DadosGerais = d;
  setEndereco = e => this.Endereco = e;  
  setEmail = e => this.Email = e;
  setTelefonePrincipal = p => this.TelefonePrincipal = p;
  setTelefoneSecundario = s => this.TelefoneSecundario = s;
  setNecessidadeEspecial = n => this.NecessidadeEspecial = n;
  setSabatista = s => this.Sabatista = s;
  setPassword = p => this.Password = p;

  async componentDidMount() {
    await this.props.loadPeriodos();

    this.setState({ ...this.state, loading: true, loadingButtonFind: true, history: filterPersistence(this.props.location) });

    const cpf = this.props.match.params.id;

    if (isCPFInvalid(cpf)) {
      this.handleError("CPF Inválido");
      setTimeout(() => this.props.history.push(`/`), 2000);
      return;
    }

    await CandidatoService.buscarInscricao(cpf)
      .then(res => {
        if (res.status === 200) {
          if (!keycloak.authenticated) {
            this.handleError("Professor Já Realizou Inscrição");
            setTimeout(() => this.props.history.push(`/inscricao`), 2000);
            return;
          
          } else {
            this.setState({ ...this.state, id: res.data.id, cpf: cpf, isInscrito: true });
            
            CandidatoService.find(res.data.id)
              .then(res => {
                const candidato = res.data;

                this.DadosGerais.setState({
                  cpf: candidato.cpf,
                  nome: candidato.nome,
                  nomeSocial: candidato.nomeSocial,
                  sexo: candidato.sexo,
                  dataNascimento: parseDate(candidato.dataNascimento),
                  raca: candidato.raca,
                  disabled: {
                    cpf: true,
                  }
                });

                this.Endereco.findCities(candidato.endereco.municipio.uf.id, candidato.endereco.municipio.codigo);
                this.Endereco.setState({
                  address: {
                    zipCode: candidato.endereco.cep,
                    address: candidato.endereco.endereco,
                    number: candidato.endereco.numero,
                    complement: candidato.endereco.complemento,
                    district: candidato.endereco.bairro,
                    city: candidato.endereco.municipio.codigo,
                    UF: candidato.endereco.municipio.uf.id,
                  },
                });

                this.Email.setState({
                  email: candidato.email,
                  emailOriginal: candidato.email,
                });

                this.TelefonePrincipal.setState({
                  phone: {
                    ddd: candidato.telefonePrincipal.ddd,
                    number: candidato.telefonePrincipal.fone,
                  },
                });

                if (candidato.telefoneAlternativo != null) { 
                  this.TelefoneSecundario.setState({
                    phone: {
                      ddd: candidato.telefoneAlternativo.ddd,
                      number: candidato.telefoneAlternativo.fone,
                    },
                  });
                }

                this.NecessidadeEspecial.setState({
                  possuiNecessidadeEspecial: candidato.necessidadeEspecial != null ? true : false,
                  necessidadeEspecial: candidato.necessidadeEspecial,
                  descricaoOutrasDeficiencias: candidato.descricaoOutrasDeficiencias,
                });

                this.Sabatista.setState({
                  sabatista: candidato.sabatista,
                });

                this.setState({
                  ...this.state,
                  naoPodeFazerAlteracao: candidato.dataFinalizacaoInscricao != null,
                })
              })
              .catch(error => {
                this.handleError();
              });
          }
        } else if (res.status === 204) {
          this.closeMenu();

          this.DadosGerais.setState({ ...this.DadosGerais.state, cpf: cpfMask(cpf), isInscrito: false });
        }
      })
      .catch(error => {
        this.handleError();
      })
      .finally(() => this.setState({ loading: false, loadingButtonFind: false }))
  }

  handleSubmit = async () => {
    this.setState({ loadingButtonSave: true });

    const formDadosGeraisIsValid = await this.DadosGerais.isValid();
    const formEnderecoIsValid = this.Endereco.isValid();
    const formEmailIsValid = await this.Email.isValid();
    const formTelefonePrincipalIsValid = this.TelefonePrincipal.isValid();
    const formTelefoneSecundarioIsValid = this.TelefoneSecundario.isValid();
    const formNecessidadeEspecialIsValid = this.NecessidadeEspecial.isValid();
    const formSabatistaIsValid = this.Sabatista.isValid();
    const formPasswordIsValid = this.Password.isValid();

    if (!formDadosGeraisIsValid || !formEnderecoIsValid || !formEmailIsValid || !formTelefonePrincipalIsValid || !formTelefoneSecundarioIsValid
      || !formNecessidadeEspecialIsValid || !formSabatistaIsValid || (!formPasswordIsValid && !this.state.isInscrito)
    ) {
      this.setState({ loadingButtonSave: false });
      this.Toast.setState({
        message: {
          message: `Houve um problema de validação nos dados informados no formulário. Revise as informações preenchidas e tente novamente.`,
          type: "warning",
          open: true
        }
      })
      return
    }

    const inscricao = {      
      cpf: this.DadosGerais.state.cpf,
      nome: this.DadosGerais.state.nome.toUpperCase().trim().replaceAll(/\s+/g, " "),
      nomeSocial: this.DadosGerais.state.nomeSocial ? this.DadosGerais.state.nomeSocial.toUpperCase().trim().replaceAll(/\s+/g, " ") : null,
      sexo: this.DadosGerais.state.sexo,
      dataNascimento: toDate(this.DadosGerais.state.dataNascimento),
      raca: this.DadosGerais.state.raca,
      
      email: this.Email.state.email,
      dddPrincipal: this.TelefonePrincipal.state.phone.ddd,
      fonePrincipal: this.TelefonePrincipal.state.phone.number,
      dddAlternativo: this.TelefoneSecundario.state.phone.ddd,
      fonaAlternativo: this.TelefoneSecundario.state.phone.number,

      necessidadeEspecial: this.NecessidadeEspecial.state.necessidadeEspecial,
      descricaoOutrasDeficiencias: this.NecessidadeEspecial.state.necessidadeEspecial === "OUTRAS" ? this.NecessidadeEspecial.state.descricaoOutrasDeficiencias : null,

      sabatista: this.Sabatista.state.sabatista,

      cep: this.Endereco.state.address.zipCode,
      endereco: this.Endereco.state.address.address.toUpperCase().trim(),
      numero: this.Endereco.state.address.number,
      complemento: this.Endereco.state.address.complement,
      bairro: this.Endereco.state.address.district.toUpperCase().trim(),
      municipio: this.Endereco.state.address.city,

      senha: !this.state.isInscrito ? this.Password.state.password : null
    }

    let request = null;
    let mensagem = null;
    
    if (this.state.isInscrito) {
      request = CandidatoService.edit(this.state.id, inscricao);

      mensagem = "Atualização Realizada com Sucesso.";
    } else {
      request = CandidatoService.add(inscricao);

      mensagem = `Sua inscrição foi iniciada com sucesso!<br /><br />`;
      mensagem += `${!keycloak.authenticated ? `Em alguns instantes você será redirecionado a área de login do sistema.` : `Inscrição realizada com sucesso.`}`;
    }

    request
      .then(res => {
        this.Toast.setState({
          message: {
            message: mensagem,
            type: "success",
            open: true
          }
        })

        setTimeout(async () => {
          !keycloak.authenticated ? await handleAutoLogin(removeCpfMask(inscricao.cpf), inscricao.senha, `${process.env.REACT_APP_PUBLIC_URL}/admin/inicial`) : this.handleBack()
        }, 2500);
      })
      .catch(error => {
        const errors = error.response.data.mensagens !== undefined && error.response.data.mensagens.length > 0 ? `${error.response.data.mensagens.map(mensagen => mensagen).join(" ")}` : "";

        this.Toast.setState({
          message: {
            message: `Ocorreu um Problema ao ${this.state.isInscrito && keycloak.authenticated ? `Atualizar` : `Realizar`} a Inscrição. ${errors}`,
            type: "error",
            open: true
          }
        })
      })
      .finally(() => this.setState({ loadingButtonSave: false }));
  }

  handleError = (message = "Ocorreu um Problema ao Buscar a Inscrição") => {
    this.Toast.setState({
      message: {
        message: message,
        type: "error",
        open: true
      }
    })
  }

  handleCancelarIncricao = () => {
    this.props.history.push(`/inscricao`);
  }

  handleBack = () => {
    if (this.state.history && this.state.history.path) {
      this.props.history.push({
        pathname: `${this.state.history.path}`,
        state: {
          history: {
            state: this.state.history.state
          }
        }
      });
    } else {
      this.props.history.goBack();
    }
  }

  render() {
    const page = `${this.props.contexts && getEdicaoCompleta(this.props.contexts)} - Ficha de Inscrição`;

    const isPodeEditarDados = isInscricoesAbertas(this.props.contexts) && !this.state.naoPodeFazerAlteracao;

    return (
      <>
        <Toast parentRef={this.setToast} />

        <Container component="main" maxWidth="xl" >
          <Box mt={keycloak.authenticated ? 2 : 0} >
            {!keycloak.authenticated ?
              <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', margin: 12 }}>
                <img src={logo} style={{ margin: 12, marginRight: 24, height: '50px' }} alt={process.env.REACT_APP_NAME_GENERAL}/>
                <Title>{page}</Title>
              </div>
            : 
              <Title>{page}</Title>
            }

            <Grid container spacing={3}>
              <Grid item sm={12} lg={12}>
                <Alert severity="info">
                  Preencha <b>TODOS</b> os campos abaixo para {!this.state.isInscrito ? `realizar` : `editar`} sua inscrição.
                </Alert>
              </Grid>
            </Grid>

            <Paper elevation={3} style={{ padding: 24, marginTop: 24 }}>
              <Grid item sm={12} lg={9}>
                <Typography variant="body2" style={{ fontSize: 16 }}><b>Dados Gerais</b></Typography>
              </Grid>

              <DadosGerais parentRef={this.setDadosGerais} disabled={!isPodeEditarDados} />
            </Paper>

            <Paper elevation={3} style={{ padding: 24, marginTop: 24 }}>
              <Grid item sm={12} lg={9}>
                <Typography variant="body2" style={{ fontSize: 16 }}><b>Endereço</b></Typography>
              </Grid>

              <Endereco parentRef={this.setEndereco} disabled={!isPodeEditarDados} />
            </Paper>

            <Paper elevation={3} style={{ padding: 24, marginTop: 24 }}>
              <Grid item sm={12} lg={9}>
                <Typography variant="body2" style={{ fontSize: 16 }}><b>Contato</b></Typography>
              </Grid>

              <Email parentRef={this.setEmail} name="Email" disabled={!isPodeEditarDados} />
              <TelefonePrincipal parentRef={this.setTelefonePrincipal} name="Telefone Principal" required={true} disabled={!isPodeEditarDados} />
              <TelefoneSecundario parentRef={this.setTelefoneSecundario} name="Telefone Secundário" required={false} disabled={!isPodeEditarDados} />
            </Paper>

            <Paper elevation={3} style={{ padding: 24, marginTop: 24 }}>
              <Grid item sm={12} lg={9}>
                <Typography variant="body2" style={{ fontSize: 16 }}><b>Você é uma Pessoa com Deficiência?</b></Typography>
              </Grid>

              <NecessidadeEspecial parentRef={this.setNecessidadeEspecial} disabled={!isPodeEditarDados} />
            </Paper>

            <Paper elevation={3} style={{ padding: 24, marginTop: 24 }}>
              <Grid item sm={12} lg={9}>
                <Typography variant="body2" style={{ fontSize: 16 }}>
                  <b>Você é Sabatista?</b>
                  <PopUpLegenda
                    texto="Sabatista é a pessoa que guarda o sábado por convicções religiosas e precisa realizar a prova após o pôr do sol"
                    anchorOrigin={{ vertical: 'center', horizontal: 'right', }}
                    transformOrigin={{ vertical: 'center', horizontal: 'left', }}
                  />
                </Typography>
              </Grid>

              <Sabatista parentRef={this.setSabatista} disabled={!isPodeEditarDados} />
            </Paper>

            {!this.state.isInscrito &&
              <Paper elevation={3} style={{ padding: 24, marginTop: 24 }}>
                <Grid item sm={12} lg={9}>
                  <Typography variant="body2" style={{ fontSize: 16 }}><b>Crie uma Senha de Acesso ao site</b></Typography>
                </Grid>

                <Grid item sm={12} lg={8}>
                  <Alert severity="info" style={{ marginTop: 24 }}>
                    <b>Guarde sua Senha</b> em um local seguro. Você precisará dela para acessar sua conta novamente no futuro. <b>Não compartilhe sua senha com ninguém</b>.
                  </Alert>
                </Grid>

                <Password parentRef={this.setPassword} />
              </Paper>
            }

            {this.state.isInscrito ?
              <ButtonsForm
                onClick={this.handleSubmit}
                onBack={this.handleBack}
                loading={this.state.loadingButtonSave}
                name={"Salvar Inscrição"}
                nameOnBack={"Voltar"}
                idFocus={`saveButton`}
                saveDisabled={!isPodeEditarDados}
              />
            :
              <ButtonsForm
                onClick={this.handleSubmit}
                onBack={!keycloak.authenticated ? this.handleCancelarIncricao : this.handleBack}
                loading={this.state.loadingButtonSave}
                name={"Realizar Inscrição"}
                nameOnBack={!keycloak.authenticated ? "Cancelar e Voltar ao Início" : "Voltar"}
                idFocus={`saveButton`}
              />
            }
          </Box>
        </Container>
      </>
    )
  }
}

const mapStateToProps = state => ({ contexts: state.periodos });
const mapDispatchToProps = dispatch => (bindActionCreators({ loadPeriodos }, dispatch));

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(InscricaoForm));